import { gql } from "@apollo/client";

// Graphql registration
export const MUTATION_REGISTER = gql`
  mutation Register(
    $password: String!
    $firstName: String!
    $middleName: String!
    $lastName: String!
    $email: String!
    $state: String!
    $city: String!
    $country: String!
    $zipCode: String!
    $address: String!
    $phone: String!
    $gender: String!
    $title: String!
    $dateOfBirth: String!
    $affiliateTrackingCode: String!
    $language: String!
    $receiveNews: Boolean!
    $receiveSMS: Boolean!
    $abode: String!
    $buildingNumber: Int!
    $buildingName: String!
    $currency: String!
    $gdprAccepted: Boolean!
    $pep: Boolean!
    $identID: String!
    $identBankID: String!
    $geoIP: String!
    $birthPlace: String!
    $BSN: String!
    $inserts: String!
    $addictionPolicy: Boolean!
    $legalCapacity: Boolean!
    $amlPolicy: Boolean!
    $receiveBonus: Boolean!
    $receiveSportsBonus: Boolean
    $activate: Boolean!
    #    $kycDocumentType: String!
    #    $kycIDNumber: String!
    #    $kycDocumentCity: String!
    #    $documentValidFrom: String!
    #    $documentValidTo: String!
    $accountHolder: String!
    $accountNumber: String!
    $limits: String!
  ) {
    register(
      password: $password
      firstName: $firstName
      middleName: $middleName
      lastName: $lastName
      email: $email
      state: $state
      city: $city
      country: $country
      zipCode: $zipCode
      address: $address
      phone: $phone
      gender: $gender
      title: $title
      dateOfBirth: $dateOfBirth
      affiliateTrackingCode: $affiliateTrackingCode
      language: $language
      receiveNews: $receiveNews
      receiveSMS: $receiveSMS
      abode: $abode
      buildingNumber: $buildingNumber
      buildingName: $buildingName
      currency: $currency
      gdprAccepted: $gdprAccepted
      pep: $pep
      identID: $identID
      identBankID: $identBankID
      geoIP: $geoIP
      birthPlace: $birthPlace
      BSN: $BSN
      inserts: $inserts
      addictionPolicy: $addictionPolicy
      legalCapacity: $legalCapacity
      amlPolicy: $amlPolicy
      receiveBonus: $receiveBonus
      receiveSportsBonus: $receiveSportsBonus
      activate: $activate
      #      kycDocumentType: $kycDocumentType
      #      kycIDNumber: $kycIDNumber
      #      kycDocumentCity: $kycDocumentCity
      #      documentValidFrom: $documentValidFrom
      #      documentValidTo: $documentValidTo
      accountHolder: $accountHolder
      accountNumber: $accountNumber
      limits: $limits
    ) {
      token
      code
    }
  }
`;

// Gaphql login to system
export const MUTATION_AUTH = gql`
  mutation Auth(
    $username: String!
    $password: String!
    $client: String!
    $nationalID: String!
  ) {
    auth(
      username: $username
      password: $password
      client: $client
      nationalID: $nationalID
    ) {
      token
      code
    }
  }
`;

// Graphql update profile
export const MUTATION_UPDATE_PROFILE = gql`
  mutation UpdateProfile(
    $phone: String
    $bonus: Boolean
    $receiveSportsBonus: Boolean
    $news: Boolean
    $sms: Boolean
    $realityCheck: Float
    $tc: Boolean
    $gdpr: Boolean
    $email: String
    $isDummy: Boolean
    $state: String
    $prestonTickets: Boolean
    $wstTickets: Boolean
  ) {
    updateProfile(
      phone: $phone
      bonus: $bonus
      news: $news
      sms: $sms
      realityCheck: $realityCheck
      tc: $tc
      gdpr: $gdpr
      email: $email
      isDummy: $isDummy
      state: $state
      receiveSportsBonus: $receiveSportsBonus
      prestonTickets: $prestonTickets
      wstTickets: $wstTickets
    ) {
      ok
    }
  }
`;

// Graphql reset password
export const MUTATION_RESET_PASSWORD = gql`
  mutation ResetPassword($email: String!) {
    resetPassword(email: $email) {
      ok
    }
  }
`;

// Graphql reset password change
export const MUTATION_RESET_PASSWORD_CHANGE = gql`
  mutation ChangeResetPassword(
    $code: String!
    $password: String!
    $cPassword: String!
  ) {
    changeResetPassword(
      code: $code
      password: $password
      cPassword: $cPassword
    ) {
      ok
    }
  }
`;

// Graphql change password
export const MUTATION_CHANGE_PASSWORD = gql`
  mutation ChangePassword(
    $oldPassword: String!
    $newPassword: String!
    $cNewPassword: String!
  ) {
    changePassword(
      oldPassword: $oldPassword
      newPassword: $newPassword
      cNewPassword: $cNewPassword
    ) {
      ok
    }
  }
`;

// Graphql login as player
export const MUTATION_LOGIN_AS_PLAYER = gql`
  mutation LoginAsPlayer($sessionID: String!) {
    loginAsPlayer(sessionID: $sessionID) {
      token
    }
  }
`;

// Graphql update banktransfer data
export const MUTATION_UPDATE_BANKTRANSFER = gql`
  mutation UpdateBanktransfer(
    $bankID: Float!
    $accountHolder: String!
    $accountNumber: String!
    $iBan: String!
    $bic: String!
    $sortCode: String!
    $bankName: String!
    $bankCountry: String!
    $clearingNumber: String!
    $bankBranch: String!
    $bankIFSC: String!
    $bankAddress: String!
    $accountType: String!
    $recipientId: String!
  ) {
    updateBanktransfer(
      bankID: $bankID
      accountHolder: $accountHolder
      accountNumber: $accountNumber
      iBan: $iBan
      bic: $bic
      sortCode: $sortCode
      bankName: $bankName
      bankCountry: $bankCountry
      clearingNumber: $clearingNumber
      bankBranch: $bankBranch
      bankIFSC: $bankIFSC
      bankAddress: $bankAddress
      accountType: $accountType
      recipientId: $recipientId
    ) {
      ok
    }
  }
`;

export const MUTATION_SET_BANKTRANSFER = gql`
  mutation SetBanktransfer(
    $accountHolder: String!
    $accountNumber: String!
    $iBan: String!
    $bic: String!
    $sortCode: String!
    $bankName: String!
    $bankCountry: String!
    $clearingNumber: String!
    $bankBranch: String!
    $bankIFSC: String!
    $bankAddress: String!
    $accountType: String!
    $recipientId: String!
  ) {
    setBanktransfer(
      accountHolder: $accountHolder
      accountNumber: $accountNumber
      iBan: $iBan
      bic: $bic
      sortCode: $sortCode
      bankName: $bankName
      bankCountry: $bankCountry
      clearingNumber: $clearingNumber
      bankBranch: $bankBranch
      bankIFSC: $bankIFSC
      bankAddress: $bankAddress
      accountType: $accountType
      recipientId: $recipientId
    ) {
      ok
    }
  }
`;

// Graphql set leaderboard name
export const MUTATION_SET_LEADERBOARD_NAME = gql`
  mutation SetLeaderboardName($leaderboard: String!) {
    setLeaderboardName(leaderboard: $leaderboard) {
      ok
    }
  }
`;

// Graphql redeem loyalty points
export const MUTATION_REDEEM_LOYALTY_POINTS = gql`
  mutation RedeemLoyaltyPoints($points: Float!) {
    redeemLoyaltyPoints(points: $points) {
      ok
    }
  }
`;

// Graphql block game by ID
export const MUTATION_BLOCK_GAME_BY_ID = gql`
  mutation BlockGameByID($gameID: String!, $duration: Float!) {
    blockGameByID(gameID: $gameID, duration: $duration) {
      ok
    }
  }
`;

// Graphql block game type
export const MUTATION_BLOCK_GAME_TYPE = gql`
  mutation BlockGameType($name: String!, $duration: Float!) {
    blockGameType(name: $name, duration: $duration) {
      ok
    }
  }
`;

// Graphql self exclude player
export const MUTATION_SELF_EXCLUDE = gql`
  mutation SelfExclude($duration: Float!) {
    selfExclude(duration: $duration) {
      ok
    }
  }
`;

// Graphql create player timeout
export const MUTATION_CREATE_TIMEOUT = gql`
  mutation CreateTimeout($duration: Float!) {
    createTimeout(duration: $duration) {
      ok
    }
  }
`;

// Graphql create player limits
export const MUTATION_CREATE_LIMITS = gql`
  mutation CreateLimits($limits: String!) {
    createLimits(limits: $limits) {
      ok
    }
  }
`;

// Graphql ack responsible gaming
export const MUTATION_ACK_RESPONSIBLE_GAMING_THRESHOLD = gql`
  mutation AckResponsibleGamingThreshold($thresholdType: String!) {
    ackResponsibleGamingThreshold(thresholdType: $thresholdType) {
      ok
    }
  }
`;

// Graphql contest risk score
export const MUTATION_CONTEST_RISK_SCORE = gql`
  mutation ContestRiskScore($eventType: String!, $nickName: String!) {
    contestRiskScore(eventType: $eventType, nickName: $nickName) {
      ok
    }
  }
`;

// Graphql award bonus code
export const MUTATION_AWARD_BONUS_CODE = gql`
  mutation AwardBonusCode($bonusCode: String!) {
    awardBonusCode(bonusCode: $bonusCode) {
      ok
    }
  }
`;

// Graphql set pre event alert
export const MUTATION_SET_PRE_EVENT_ALERT = gql`
  mutation SetPreEventAlert($eventType: String!, $eventAnswers: String!) {
    setPreEventAlert(eventType: $eventType, eventAnswers: $eventAnswers) {
      ok
    }
  }
`;

// Graphql set manual event answer request
export const MUTATION_SET_MANUAL_EVENT_ANSWER_REQUEST = gql`
  mutation SetManualEventAnswerRequest(
    $eventType: String!
    $eventAnswers: String!
  ) {
    setManualEventAnswerRequest(
      eventType: $eventType
      eventAnswers: $eventAnswers
    ) {
      ok
    }
  }
`;

// Graphql award sports bonus code
export const MUTATION_AWARD_SPORTS_BONUS_CODE = gql`
  mutation AwardSportsBonus($bonusCode: String!) {
    awardSportsBonus(bonusCode: $bonusCode) {
      ok
    }
  }
`;

// Graphql award manual bonus code
export const MUTATION_AWARD_MANUAL_BONUS_CODE = gql`
  mutation AwardManualBonusCode($bonusCode: String!) {
    awardManualBonusCode(bonusCode: $bonusCode) {
      ok
    }
  }
`;

// Graphql award manual sports bonus code
export const MUTATION_AWARD_MANUAL_SPORTS_BONUS_CODE = gql`
  mutation AwardSportsBonus($bonusCode: String!) {
    awardSportsBonus(bonusCode: $bonusCode) {
      ok
    }
  }
`;

// Graphql cancel bonus
export const MUTATION_CANCEL_BONUS = gql`
  mutation CancelBonus($uniqueID: String!) {
    cancelBonus(uniqueID: $uniqueID) {
      ok
    }
  }
`;

// Graphql cancel sports bonus
export const MUTATION_CANCEL_SPORTS_BONUS = gql`
  mutation CancelSportsbookBonus($uniqueID: String!) {
    cancelSportsbookBonus(uniqueID: $uniqueID) {
      ok
    }
  }
`;

// Graphql affordability check on fist deposit
export const MUTATION_AFFORDABILLITY_CHECK = gql`
  mutation AffordabilityCheck(
    $occupation: String!
    $employment: String!
    $sourceOfWealth: String!
    $sourceOfFunds: String!
    $annualIncome: String!
    $gamblingBudget: String!
  ) {
    affordabilityCheck(
      occupation: $occupation
      employment: $employment
      sourceOfWealth: $sourceOfWealth
      sourceOfFunds: $sourceOfFunds
      annualIncome: $annualIncome
      gamblingBudget: $gamblingBudget
    ) {
      popupVersion
      limitAmount
    }
  }
`;

// Graphql set hooyu journey to pending
export const MUTATION_HOOYU_PENDING = gql`
  mutation SetJourneyPendingStatus($link: String!) {
    setJourneyPendingStatus(link: $link) {
      ok
    }
  }
`;

// Graphql Nett Deposit Limit set
export const MUTATION_SET_NETT_DEPOSIT_LIMIT = gql`
  mutation SetNettDepositLimit($limitType: String!) {
    setNettDepositLimit(limitType: $limitType) {
      ok
    }
  }
`;

// Graphql Rolling Deposit Limit set
export const MUTATION_ACCEPT_ROLLING_DEPOSIT_LIMIT = gql`
  mutation SetRollingDepositLimit($limitRegime: String!) {
    setRollingDepositLimit(limitRegime: $limitRegime) {
      ok
    }
  }
`;

// Graphql set deposit limit regime (nett / gross)
export const MUTATION_SET_DEPOSIT_LIMIT_REGIME = gql`
  mutation SetDepositLimitRegime($limitRegime: String!) {
    setDepositLimitRegime(limitRegime: $limitRegime) {
      ok
    }
  }
`;

// Graphql update data link
export const MUTATION_UPDATE_DATA_LINK = gql`
  mutation UpdateDataLink(
    $consentId: String!
    $bankReferenceId: String!
    $dataLinkId: String!
  ) {
    updateDataLink(
      consentId: $consentId
      bankReferenceId: $bankReferenceId
      dataLinkId: $dataLinkId
    ) {
      ok
    }
  }
`;

export const MUTATION_SET_NEWS_AND_PROMOTIONS_OPT_IN = gql`
  mutation SetNewsAndPromotionsOptIn($newsId: String!) {
    setNewsAndPromotionsOptIn(newsId: $newsId) {
      ok
    }
  }
`;

// Graphql RTS12 prompt review dialog
export const MUTATION_PROMPT_REVIEW_DIALOG = gql`
  mutation SetRts12($duration: Float!) {
    setRts12(duration: $duration) {
      ok
    }
  }
`;

// Graphql cancel set limit popup
export const MUTATION_CANCEL_SET_LIMIT_POPUP = gql`
  mutation CancelSetLimitPopup {
    cancelSetLimitPopup {
      ok
    }
  }
`;

export const MUTATION_SET_DEPOSIT_LIMIT_UKGC = gql`
  mutation CreateDepositLimit($limitType: String!, $initialAmount: Float!) {
    createDepositLimit(limitType: $limitType, initialAmount: $initialAmount) {
      ok
    }
  }
`;

export const MUTATION_ACKNOWLEDGE_RISK_SCORE = gql`
  mutation AcknowledgeRiskScore(
    $nickName: String!
    $eventType: String!
    $acknowledgeType: String
  ) {
    acknowledgeRiskScore(
      nickName: $nickName
      eventType: $eventType
      acknowledgeType: $acknowledgeType
    ) {
      ok
    }
  }
`;

export const MUTATION_ACKNOWLEDGE_REFUND = gql`
  mutation AcknowledgeRefund($nickName: String!) {
    acknowledgeRefund(nickName: $nickName) {
      ok
    }
  }
`;

export const MUTATION_RG_CONTACT_SUPPORT = gql`
  mutation RgContactSupport($nickName: String!, $message: String!) {
    rgContactSupport(nickName: $nickName, message: $message) {
      ok
    }
  }
`;
